import { pushToDataLayer } from '@domain-group/fe-helper';

import * as ga from '../../../constants/ga';

const emailButtonClick = () =>
  pushToDataLayer({
    event: ga.event,
    eventAction: 'Email Button Click',
    eventCategory: ga.category.INTERACTION,
    eventLabel: 'Agent Profile',
  });

export default emailButtonClick;
